module.exports = __webpack_public_path__ + "static/media/switch-off.49e9525a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro/switch-off.png
// module id = 248
// module chunks = 0